import Typography from "@mui/material/Typography";

const FieldError = ({ message }) =>
  message ? (
    <Typography
      sx={{
        fontSize: "12px",
        color: "error.main",
        marginTop: "4px",
      }}
    >
      {message}
    </Typography>
  ) : null;

export default FieldError;
